import { Component, Input } from '@angular/core';

import { ContentTheme } from '../../models';

@Component({
  selector: 'wl-partial-brand-header',
  templateUrl: './brand-header.component.html',
  styleUrls: ['./brand-header.component.ed.scss'],
  standalone: true,
})
export class BrandHeaderComponent {
  /**
   * Defines the theming of the brand header.
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() theme: ContentTheme = 'default';
  /**
   * Main header text.
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() heading?: string;
  /**
   * Sub header text.
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() subheading?: string;
  /**
   * When enabled, the headings will be inlined instead of starting the subheading on a new line.
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() inlineHeadings?: boolean = false;
  /**
   * Defines whether or not the backdrop should stretch to the side of the screen.
   */
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stretchBackdrop?: boolean = false;
}
